import { useEffect, useRef } from 'react';
import { Button, MenuList, MenuListItem, Separator } from 'react95';
import { useLocale } from '../i18n/LocaleContext';

const SettingsMenu = ({ open, onOpenChange }) => {
  const { lang, setLang, t } = useLocale();
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const onPointerDown = (event) => {
      if (!rootRef.current?.contains(event.target)) {
        onOpenChange(false);
      }
    };

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        onOpenChange(false);
      }
    };

    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('pointerdown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open, onOpenChange]);

  const chooseLang = (nextLang) => {
    setLang(nextLang);
    onOpenChange(false);
  };

  return (
    <div className="settings-menu" ref={rootRef}>
      <Button
        variant="menu"
        active={open}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => onOpenChange(!open)}
      >
        {t.settings}
      </Button>

      {open && (
        <MenuList className="settings-dropdown" role="menu" aria-label={t.settings}>
          <MenuListItem disabled size="sm">
            {t.language}
          </MenuListItem>
          <Separator />
          <MenuListItem
            size="sm"
            primary={lang === 'ru'}
            role="menuitemradio"
            aria-checked={lang === 'ru'}
            onClick={() => chooseLang('ru')}
          >
            {lang === 'ru' ? '✓ ' : ''}
            {t.langRu}
          </MenuListItem>
          <MenuListItem
            size="sm"
            primary={lang === 'en'}
            role="menuitemradio"
            aria-checked={lang === 'en'}
            onClick={() => chooseLang('en')}
          >
            {lang === 'en' ? '✓ ' : ''}
            {t.langEn}
          </MenuListItem>
        </MenuList>
      )}
    </div>
  );
};

export default SettingsMenu;
